import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';

interface CustomDialogProps {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  actions?: React.ReactNode;
  showCloseButton?: boolean;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
}

function CustomDialog({
  open,
  title,
  description,
  onClose,
  actions,
  showCloseButton = true,
  disableBackdropClick = false,
  disableEscapeKeyDown = false,
}: CustomDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick={disableBackdropClick}
      disableEscapeKeyDown={disableEscapeKeyDown}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-description"
    >
      <DialogTitle id="custom-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="custom-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {actions || (showCloseButton && <Button onClick={onClose} color="primary">Fechar</Button>)}
      </DialogActions>
    </Dialog>
  );
}

export default CustomDialog;
